






















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import Error from '@/components/Error.vue';
import Success from '@/components/Success.vue';
import ConfirmedAction from '@/components/ConfirmedAction.vue';
import { Enterprise } from '@/types';
import { ApiClient, curApiClient } from '@/services/ApiClient';

@Component({
  components: {
    Error,
    Success,
    ConfirmedAction
  },
})
export default class DeleteEnterprise extends Vue {

  @Prop({ default: {},  type: Object}) enterprise!: Enterprise;

  error:string = '';
  success:string = '';

  private apiClient:ApiClient = curApiClient;
  
  async deleteItem() {

    const reply = await this.apiClient.deleteEnterprise(this.enterprise.enterpriseId);
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to delete enterprise: ${reply.errorMsg}`;
    
    this.setSuccess(`Enterprise ${this.enterprise.enterpriseId} has been deleted`);
  }


  setSuccess(str:string) {
    this.success = str;
    setTimeout(() => this.$emit('cancel'), 1000);
  }

  cancel() {
    this.$emit('cancel');
  }
}
